<template>
    <div class="yt-student-subject-list">
        <GridTable
            ref="gridTable"
            id="StudentSubjectList"
            :title="`${title}${appendTitle || ''}`"
            urlPath="subjectsTutorsCms"
            :columns="columns"
            :schema="schema"
            :supportAddNew="false"
            :hasEditItem="false"
            :hasDeleteItem="false"
            :filterUrlUpdate="onFilterUrlUpdate"
            :defaultServerParams="{ tutorId: id }">
            <template v-slot:customButtons="slotProps">
                <!-- <router-link :to="{ name: 'StudentDetail', params: { id: slotProps.props.row._id }}" class="btn btn-success">View</router-link> -->
                <!-- <button v-if="slotProps.props.row.subjects.status === 'approved'" class="btn btn-primary" @click="slotProps.openDinamicViewModal(slotProps.props)">View</button> -->
                <ModalComponent
                    v-if="slotProps.props.row.subjects.status === 'approved'"
                    :id="slotProps.props.row.originalIndex"
                    width="90%"
                    :component="modalTutorSubjectDetail(slotProps.props.row)">
                    View
                </ModalComponent>
                <!-- <button v-if="slotProps.props.row.subjects.status === 'approved'" class="btn btn-success" type="button">View</button> -->
                <button v-else-if="slotProps.props.row.subjects.status === 'pending'" class="btn btn-info" type="button" @click="slotProps.onUpdateField(slotProps.props, 'approved', 'subjects.status')">Approve</button>
            </template>
        </GridTable>
    </div>
</template>

<script>
import { Component, Prop } from 'vue-property-decorator'
// import { namespace } from 'vuex-class'
// import VueFormGenerator from 'vue-form-generator'

import BaseList from '@/components/BaseList'

// const appModule = namespace('app')
// const subjectsModule = namespace('subjects')

@Component()
export default class StudentSubjectList extends BaseList {
    @Prop({
        type: String,
        required: true,
        default: null
    })
    id

    title = 'Subjects'

    statusOptions = [
        { value: 'approved', text: 'Approved' },
        { value: 'pending', text: 'Pending' },
        { value: 'declined', text: 'Declined' }
    ]

    columns = [
        {
            label: 'ID',
            field: '_id',
            hidden: true
        },
        {
            label: 'Active',
            field: 'subjects.isActive',
            type: 'switch'
        },
        {
            label: 'Subject',
            field: 'subjects.name'
        },
        {
            label: 'Total Lessons',
            field: 'subjects.totalLessons',
            type: 'number'
        },
        {
            label: 'Total Minutes',
            field: 'subjects.totalMinutes',
            type: 'number'
        },
        {
            label: '+ Rates',
            field: 'subjects.totalPositiveRates',
            type: 'number'
        },
        {
            label: '- Rates',
            field: 'subjects.totalNegativeRates',
            type: 'number'
        },
        {
            label: 'Registration Date',
            field: 'subjects.registrationDate'
            // type: 'date',
            // dateInputFormat: 'YYYY-MM-DD', // expects 2018-03-16
            // dateOutputFormat: 'MMM Do YYYY'
        },
        {
            label: 'Status',
            field: 'subjects.status',
            type: 'dropdown',
            options: this.statusOptions
        },
        {
            label: 'Actions',
            field: 'actions'
            /* type: 'dinamicView',
            dinamicView: {
                buttonLabel: 'View',
                modalTitle: 'Lesson Detail',
                component: () => import('@/components/lessons/LessonDetail')
            } */
        }
    ]

    schema = null

    onFilterUrlUpdate (defaultUrl, props) {
        return `${defaultUrl}?subjectId=${props.row.subjects.subject}`
    }

    modalTutorSubjectDetail (item) {
        return {
            modalTitle: 'Subject Detail',
            component: () => import('@/components/students/_TutorSubjectDetail'),
            componentProps: {
                item,
                statusOptions: this.statusOptions
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/students/_StudentSubjectList.vue